module.exports = __webpack_public_path__ + "media/images/shared/news-placeholder-9c64ad77a6302470881fbb6393f72059.jpg";